import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { FEED_DETAILS } from "../../../constants/route-constants";
import "../../Dashboard/style.sass";
import SocialIcon from "../../NewsAndAnalysis/SocialIcon";
import { formatDate, getTime } from "../../../utility/common-methods.jsx";
import {
  CONSTANTS,
  VERTICALS,
  SOCIAL_SOURCES,
  LANGUAGE_CODES,
  DATE_FORMATS,
} from "../../../constants/app-constant";

const { DATA_NOT_FOUND } = CONSTANTS;
const { YOUTUBE, FACEBOOK, INSTAGRAM, TWITTER, PINTEREST } = SOCIAL_SOURCES;

const SingleInsightFeed = (props) => {
  const [isSelected, setSelected] = useState(checked);
  const { V_SOCIAL, V_BLOG, V_FORUM, TWITTER_INSIGHTS } = VERTICALS;
  const {
    attachments,
    channel_type,
    checked = false,
    comment_count,
    created_at,
    entityName,
    from_username,
    id,
    isModal,
    lang,
    like_count,
    dislike_count,
    media_link,
    media_type,
    message,
    name,
    onFeedSelect,
    page_details,
    permalink,
    selectedVertical,
    share_count,
    title,
    clientId,
    feedsToShare = [],
    allArticleList,
    view_count,
    user_followers_count,
    selectedFilter,
    ChannelType
  } = props;

  const feedEntityName = selectedFilter ? selectedFilter.label : "";
  const news = {
    message,
    like_count,
    comment_count,
    share_count,
    id,
    channel_type,
    media_type,
    media_link,
    attachments,
    permalink,
    page_details,
    name,
    title,
    from_username,
    entityName: feedEntityName,
  };

  const isFeedSelected = () => {
    try {
      const isSel = feedsToShare.filter((fts) => fts.id == id)[0];
      return isSel;
    } catch (e) {
      return false;
    }
  };

  const handleClick = () => {
    let redirectParam = "sad";
    if (selectedVertical == V_SOCIAL) {
      redirectParam = "sad";
    } else if (selectedVertical == V_BLOG || selectedVertical == V_FORUM) {
      redirectParam = "bafad";
    }
    localStorage.setItem("articleIdList", JSON.stringify(allArticleList));
    window.open(
      `https://${window.location.host}${FEED_DETAILS}/${redirectParam}/${clientId}-${ChannelType}/${id}?entityName="${feedEntityName}"`,
      "_blank"
    );
  };

  const gotoPermalink = () => {
    if (!permalink) return;
    window.open(permalink, "_blank");
  };
  const feedSelect = () => {
    onFeedSelect && onFeedSelect(news);
  };

  const pageTitle = `@${from_username}`;

  const getCorrectTitle = () => {
    if (channel_type == FACEBOOK) {
      return name;
    }
    // else if (channel_type == PINTEREST) {
    //   return truncate(title);
    // }
    return truncate(pageTitle);
  };

  function truncate(source, size = 150) {
    return source && source.length > size
      ? source.slice(0, size - 1) + "…"
      : source;
  }

  const renderTwitterFeed = () => {
    const { display_picture, name = "" } = page_details || {};
    return (
      <>
        <div className="inner-feed-container" key={id}>
          <Card className="innerFeedItem socialFeedItem cardnew" body key={id}>
            <div className="headlineWrapper">
              <label className="inputWrap">
                <input
                  type="checkbox"
                  className="styled-checkbox"
                  defaultChecked={isFeedSelected()}
                  onClick={(e) => e.stopPropagation()}
                  onChange={() => feedSelect(news)}
                />
                <span className="checkmark"></span>
              </label>
              <div className="feedInfoHeader" style={{ width: "auto" }}>
                <div className="feedNamePic">
                  {display_picture && (
                    <>
                      {display_picture && (
                        <img src={display_picture} className="feedPic" />
                      )}
                      <span className="feedName">{name || ""}</span>
                    </>
                  )}
                  <span className="feedName">{getCorrectTitle()}</span>
                </div>
                {pageTitle && TWITTER && <span className="feedDivider"></span>}
                <div className="feedChannelDate">
                  <SocialIcon type={ChannelType} />
                  <span className="newsDate">
                    {/* <span className="ndDate">{formatDate(created_at) || DATA_NOT_FOUND}</span>{" "} */}
                  </span>
                </div>
              </div>
            </div>
            <div className="feedDetails" onClick={() => handleClick()}>
              {truncate(message)}
            </div>
            <div className="metaTagsWrap">
              <div className="mtLeft">
                <span className="label-span">Entity :</span>{" "}
                <span>{feedEntityName}</span>
              </div>
              <div className="mtRight socialData">
                <div className="mtWrap">
                  <span className="label-span">Likes :</span>{" "}
                  <span>{like_count}</span>
                </div>
                <div className="mtWrap">
                  <span className="label-span">Comments :</span>{" "}
                  <span>{comment_count}</span>
                </div>
                {channel_type !== INSTAGRAM?
                  <div className="mtWrap">
                    <span className="label-span">Share :</span>{" "}
                    <span>{share_count}</span>
                  </div>
                  :""}
              </div>
            </div>
          </Card>
        </div>
      </>
    );
  };
  const renderTwitterModalFeed = () => {
    const { display_picture, name = "" } = page_details || {};

    return (
      <>
        <div className="inner-feed-container" key={id}>
          <Card className="innerFeedItem socialFeedItem" body key={id}>
            <div className="headlineWrapper">
              <label className="inputWrap">
                <input
                  type="checkbox"
                  className="styled-checkbox"
                  defaultChecked={isFeedSelected()}
                  onClick={(e) => e.stopPropagation()}
                  onChange={() => feedSelect(news)}
                />
                <span className="checkmark"></span>
              </label>
              <div className="feedInfoHeader">
                <div className="feedNamePic">
                  <>
                    {channel_type == FACEBOOK && display_picture && (
                      <img src={display_picture} className="feedPic" />
                    )}
                    <span className="feedName">{truncate(pageTitle)}</span>
                  </>
                </div>
                {pageTitle && ChannelType && <span className="feedDivider"></span>}
                <div className="feedChannelDate">
                  <SocialIcon type={ChannelType} />
                </div>
              </div>
            </div>
            <div className="feedDetails" onClick={() => handleClick()}>
              {truncate(message)}
            </div>
            <div className="metaTagsWrap">
              <div className="mtRight socialData">
                {/* <div className="mtWrap">
                  <span className="label-span">Retweets :</span>{" "}
                  <span>{share_count}</span>
                </div> */}

                <div className="mtWrap">
                  <span className="label-span">Comments :</span>{" "}
                  <span>{comment_count}</span>
                </div>
                {channel_type !== INSTAGRAM?
                  <div className="mtWrap">
                    <span className="label-span">Share :</span>{" "}
                    <span>{share_count}</span>
                  </div>
                  :""}
                <div className="mtWrap">
                  <span className="label-span">Publish Date :</span>{" "}
                  <span>
                    {formatDate(
                      new Date(created_at),
                      DATE_FORMATS.DDMMYYYY_dash
                    )}
                  </span>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </>
    );
  };

  return (
    <React.Fragment key={feedsToShare.length}>
      {!isModal ? renderTwitterFeed() : renderTwitterModalFeed()}
    </React.Fragment>
  );
};

export default SingleInsightFeed;
